import { createSelector } from 'reselect';
import { format } from 'date-fns';
import { RootState } from 'lib/centralStore';
import { initialState } from './virtualSlice';

export const _self = (state: RootState) => {
  return state?.virtual ?? initialState;
};

export const selectTs = createSelector([_self], ({ ts }) => ts);
export const selectSlug = createSelector([_self], ({ slug }) => slug ?? '');
export const selectIsOpenTab = createSelector([_self], (state) => state.isOpenTab);
export const selectScommessa = createSelector([_self], (state) => state.scommessa);
export const selectIsLoading = createSelector([_self], ({ isLoading }) => isLoading ?? false);
export const selectVirtualNav = createSelector([_self], ({ menu }) => menu ?? []);
export const selectCurrentTime = createSelector([_self], ({ currentTime }) => currentTime?.getTime() ?? 0);
export const selectIndexGiornata = createSelector([_self], (state) => state.indexGiornata);
export const selectAvvenimentoList = createSelector([selectScommessa], (scommessa) => scommessa?.avvenimentoList ?? []);
export const selectIndexGiornataTipoScommessa = createSelector([_self], (state) => state.indexGiornataTipoScommessa);

/*
type AvvenimentoCorsaType = VirtualTemplateAvvenimentoResponseApi & VirtualTemplateAvvenimentoCorse
export const selectGetAvvenimentoCorsa = createSelector([(state: RootState, corsa: string) => virtualApi.endpoints.getVirtualTemplateAvvenimentoCorsa.select(corsa)(state)], (raw) => {
  return raw.data ?? {} as AvvenimentoCorsaType 
});
*/

export const selectTimeIsGreaterThanTenMinutes = createSelector(
  [
    (_state: RootState, dataInizio: any) => dataInizio,
    (state: RootState, _dataInizio: any) => selectCurrentTime(state),
  ],
  (dataInizio, currentTime) => {
    const differenceSeconds = (new Date(dataInizio!).getTime() - currentTime) / 1000;
    if (differenceSeconds > 600) {
      return {
        timeIsGreaterThanTenMinutes: true,
        hour: format(new Date(dataInizio!), 'kk'),
      };
    }
    return { timeIsGreaterThanTenMinutes: false, hour: '' };
  }
);

export const selectEventDates = createSelector(
  [
    (state: RootState, _time, _duration: number) => selectCurrentTime(state),
    (_state: RootState, time: any, _duration: number) => time,
    (_state: RootState, _time: any, duration: number) => duration,
  ],
  (now, time, duration) => {
    let isClosed = false;
    let isStarted = false;

    if (!!time) {
      const dtRelated = new Date(time).getTime();

      isStarted = dtRelated <= now;
      if (isStarted && dtRelated + duration < now) {
        isClosed = true;
      }
    }

    // console.log('xxx - selectEventDates', time, new Date(now).toISOString(), isStarted, isClosed )

    return { isClosed, isStarted };
  }
);
